/* Layout */
import Layout from '@/views/layout/Layout';

export default [
  {
    path: '/selfcouponManage',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '自营-商城优惠券',
      icon: 'component',
    },
    children: [
      {
        path: '/selfcouponManage/coupondata',
        component: () => import('@/myviews/shoppMall/selfcouponManage/coupondata/coupondataList.vue'),
        name: 'coupondataList',
        hidden: false,
        meta: {
          title: '优惠券数据',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/selfcouponManage/fullSessionCoupon',
        component: { render(c) { return c('router-view') } },
        name: 'fullSessionCoupon',
        meta: {
          alwaysShow: false,
          title: '全场券活动',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
        children: [
          {
            path: '/selfcouponManage/fullSessionCoupon/addfullSessionCoupon',
            component: () => import('@/myviews/shoppMall/selfcouponManage/fullSessionCoupon/addfullSessionCoupon.vue'),
            alwaysShow: false,
            name: 'addfullSessionCoupon',
            meta: {
              title: '添加全场券',
              roles: ['add', "modify", "viewpage"],
              have: [],
            }
          },
          {
            path: '/selfcouponManage/fullSessionCoupon/fullSessionCouponList',
            component: () => import('@/myviews/shoppMall/selfcouponManage/fullSessionCoupon/fullSessionCouponList.vue'),
            alwaysShow: false,
            name: 'fullSessionCouponList',
            meta: {
              title: '全场券列表',
              roles: ['add', "modify", "viewpage"],
              have: [],
            }
          },
          {
            path: '/selfcouponManage/fullSessionCoupon/nofullSessionCoupon',
            component: () => import('@/myviews/shoppMall/selfcouponManage/fullSessionCoupon/nofullSessionCoupon.vue'),
            alwaysShow: false,
            name: 'nofullSessionCoupon',
            meta: {
              title: '不可用普通全场券',
              roles: ['add', "modify", "viewpage"],
              have: [],
            }
          },
        ]
      },
      {
        path: '/selfcouponManage/productCoupon',
        component: { render(c) { return c('router-view') } },
        alwaysShow: false,
        name: 'productCoupon',
        meta: {
          title: '商品优惠券活动',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
        children: [
          {
            path: '/selfcouponManage/productCoupon/addproductCoupon',
            component: () => import('@/myviews/shoppMall/selfcouponManage/productCoupon/addproductCoupon.vue'),
            alwaysShow: false,
            name: 'addproductCoupon',
            meta: {
              title: '添加商品优惠券',
              roles: ['add', "modify", "viewpage"],
              have: [],
            }
          },
          {
            path: '/selfcouponManage/productCoupon/productCouponList',
            component: () => import('@/myviews/shoppMall/selfcouponManage/productCoupon/productCouponList.vue'),
            alwaysShow: false,
            name: 'productCouponList',
            meta: {
              title: '商品优惠券列表',
              roles: ['add', "modify", "viewpage"],
              have: [],
            }
          },
          {
            path: '/selfcouponManage/productCoupon/noproductCoupon',
            component: () => import('@/myviews/shoppMall/selfcouponManage/productCoupon/noproductCoupon.vue'),
            alwaysShow: false,
            name: 'noproductCoupon',
            meta: {
              title: '不可用商品券列表',
              roles: ['add', "modify", "viewpage"],
              have: [],
            }
          },
        ]
      },
      {
        path: '/selfcouponManage/freightCoupon',
        component: { render(c) { return c('router-view') } },
        alwaysShow: false,
        name: 'productCoupon',
        meta: {
          title: '运费券活动',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
        children: [
          {
            path: '/selfcouponManage/freightCoupon/addfreightCoupon',
            component: () => import('@/myviews/shoppMall/selfcouponManage/freightCoupon/addfreightCoupon.vue'),
            alwaysShow: false,
            name: 'addfreightCoupon',
            meta: {
              title: '添加运费券',
              roles: ['add', "modify", "viewpage"],
              have: [],
            }
          },
          {
            path: '/selfcouponManage/freightCoupon/freightCouponList',
            component: () => import('@/myviews/shoppMall/selfcouponManage/freightCoupon/freightCouponList.vue'),
            alwaysShow: false,
            name: 'freightCouponList',
            meta: {
              title: '运费券列表',
              roles: ['add', "modify", "viewpage"],
              have: [],
            }
          },
        ]
      },
      {
        path: '/selfcouponManage/batchGuide',
        component: { render(c) { return c('router-view') } },
        alwaysShow: false,
        name: 'productCoupon',
        meta: {
          title: '批量导券管理',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
        children: [
          {
            path: '/selfcouponManage/batchGuide/batchGuideList',
            component: () => import('@/myviews/shoppMall/selfcouponManage/batchGuide/batchGuideList.vue'),
            alwaysShow: false,
            name: 'batchGuideList',
            meta: {
              title: '发放活动列表',
              roles: ['add', "modify", "viewpage"],
              have: [],
            }
          },
           {
            path: '/selfcouponManage/batchGuide/addbatchGuide',
            component: () => import('@/myviews/shoppMall/selfcouponManage/batchGuide/addbatchGuide.vue'),
            alwaysShow: false,
            hidden: true, // 不是菜单项
            name: 'batchGuideList',
            meta: {
              title: '创建发放优惠券活动',
              roles: ['add', "modify", "viewpage"],
              have: [],
            }
          },
        ]
      },
      {
        path: '/activityManage/firstActivity',
        component: () => import('@/myviews/shoppMall/activityManage/firstActivity/firstActivity.vue'),
        name: 'firstActivity',
        hidden: false,
        meta: {
          title: '用户签收',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/shoppMall/selfcouponManage.js